import axiosIns from '../../../xaxios';
import { obtenerUrlAPIComisiones } from '../utils/funciones';

export default {
  async create(datos) {
    return await axiosIns.post(obtenerUrlAPIComisiones('categorias-equivalentes'), datos);
  },
  async findAll() {
    return await axiosIns.get(obtenerUrlAPIComisiones('categorias-equivalentes'));
  },
  async findOne(id) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`categorias-equivalentes/${id}`));
  },
  async update(id, datos) {
    return await axiosIns.patch(obtenerUrlAPIComisiones(`categorias-equivalentes/${id}`), datos);
  },
  async remove(id) {
    return await axiosIns.delete(obtenerUrlAPIComisiones(`categorias-equivalentes/${id}`));
  },
  async findByInstitucion(institucionId) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`categorias-equivalentes/instituciones/${institucionId}`));
  },
};
